import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CardUser } from './CardUser';

export default function Acordion() {
  const printCard = (e: any) => {
    e.preventDefault();
    window.print();
  };
  return (
    <div>
      <Accordion sx={{backgroundColor: 'transparent', boxShadow:'0', }}>
        <AccordionSummary
        sx={{ maxWidth: 450, mx: 'auto', px: 0}}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography sx={{
            textAlign: 'center',
            color: 'primary.main',
            alignContent: 'center',
            fontSize: '1.8rem',
            my: 2,
            textDecoration: 'underline'
            }} variant='h5'>Verifique aqui sua carteirinha</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{px:0}}>
        <CardUser />
        <Typography
           sx={{color: '#424949', marginTop: '2vh', fontSize: '1rem'}}
           align='center'>
          *Não se preocupe, a carteirinha será enviada para seu email assim que a compra for concluída*
          </Typography>
        </AccordionDetails>
      </Accordion>
     
    </div>
  );
}
